'use strict';

var GridToolbarUserManagementManageAccessRequestsDirective = function GridToolbarUserManagementManageAccessRequestsDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/grid-toolbar-user-management-manage-access-requests.html')
  };
};
GridToolbarUserManagementManageAccessRequestsDirective.$inject = [];
module.exports = GridToolbarUserManagementManageAccessRequestsDirective;